import { render, staticRenderFns } from "./formattedIncidentReportName.vue?vue&type=template&id=639de529"
import script from "./formattedIncidentReportName.vue?vue&type=script&lang=js"
export * from "./formattedIncidentReportName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports